import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { each, forOwn } from 'lodash';
// import { StudentPanel } from '../../../../../app/shared/constants/student-panel.constant';
import { LocalStorageService } from '../../../../shared/services/web-storage/local-storage/local-storage.service';
import StudentPanelsConfig from '../../../student-container/student-panels.config';

type TValidIconDirections = 'down' | 'up';
@Component({
  selector: 'ssv-collapse-panels-widget',
  template: require('./profile-collapse-panels-widget.component.html'),
})
export class ProfileCollapsePanelsWidget implements OnInit {
  panelMenu;
  ssvCollapsedPanels: any;
  ssvOpenPanels: any;
  collapse: boolean;
  iconDirection: TValidIconDirections;
  label: string;
  collapseLabel: string;
  expandLabel: string;

  @Output() collapsedPanelsUpdatedEvent: EventEmitter<any> = new EventEmitter();

  constructor(
    // @Inject('$scope') private $scope,
    private localstorage: LocalStorageService,
  ) {
    this.ssvCollapsedPanels = this.localstorage.getItem('ssvCollapsedPanels') || [];
    this.ssvOpenPanels = this.localstorage.getItem('ssvOpenPanels') || [];
    this.iconDirection = this.ssvOpenPanels.length > 0 ? 'up' : 'down';

    // calls ng1 panels. replace with panel config.
    this.panelMenu = this.createMenuModel(StudentPanelsConfig);
    this.collapseLabel = 'Collapse panels';
    this.expandLabel = 'Expand panels';
  }

  public ngOnInit(): void {
    if (this.ssvCollapsedPanels && this.ssvCollapsedPanels.length) {
      this.label = this.expandLabel;
      this.collapse = false;
    } else {
      this.label = this.collapseLabel;
      this.collapse = true;
    }
  }

  // creates model for checkboxes within md-menu
  createMenuModel(menuConst) {
    const menuObject = {};
    forOwn(menuConst, v => {
      menuObject[v.id] = true;
    });
    return menuObject;
  }

  togglePanels() {
    if (this.collapse) {
      this.collapseAllPanels();
      this.iconDirection = 'down';
      this.collapse = false;
    } else {
      this.expandAllPanels();
      this.iconDirection = 'up';
      this.collapse = true;
    }
  }

  collapseAllPanels() {
    this.ssvCollapsedPanels = [];
    each(this.panelMenu, (panel, id: string) => {
      this.ssvCollapsedPanels.push(id);
    });
    this.localstorage.setItem('ssvCollapsedPanels', this.ssvCollapsedPanels);
    this.localstorage.setItem('ssvOpenPanels', []);
    this.collapsedPanelsUpdatedEvent.emit({ name: 'collapse', panels: this.ssvCollapsedPanels });
    this.label = this.expandLabel;
  }

  expandAllPanels() {
    this.ssvOpenPanels = [];
    each(this.panelMenu, (panel, id: string) => {
      this.ssvOpenPanels.push(id);
    });
    this.localstorage.setItem('ssvCollapsedPanels', []);
    this.localstorage.setItem('ssvOpenPanels', this.ssvOpenPanels);
    this.collapsedPanelsUpdatedEvent.emit({ name: 'expand', panels: [] });
    this.label = this.collapseLabel;
  }
}
